/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "styles/global.module.scss";

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
    // GSAP useEffectによるレイアウト変更後にも先頭へ
    setTimeout(() => window.scrollTo(0, 0), 50);
  }
};
